"use strict";

exports.__esModule = true;

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _lodash = require("lodash");

var _lodash2 = _interopRequireDefault(_lodash);

var _glamor = require("glamor");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ Components
// import { Elements } from '@bodhi-project/typography';

// ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ Abstractions
var Fragment = _react2.default.Fragment;

// ----------------------------------------------------------------------------
// --------------------------------------------------------------------- Styles
// ----------------------------------------------------------------------------
// ----------------------------------------------------------------------------
// -------------------------------------------------------------------- Imports
// ----------------------------------------------------------------------------
// ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ Libraries

var tocStyle = (0, _glamor.css)({
  "& .md-pages": {
    paddingLeft: "1.25em",
    listStyle: "none",

    "& li": {
      fontSize: "inherit !important",
      position: "relative",

      "&:first-child": {
        marginTop: 20
      },

      "&:last-child": {
        marginBottom: "20px !important"
      },

      "&:before": {
        content: "\"\"",
        display: "block",
        borderTop: "1.375px solid #363636",
        borderLeft: "1.375px solid #363636",
        height: "100%",
        width: "0.35em",
        position: "absolute",
        bottom: "-0.65em",
        left: "-0.65em"
      },

      "&:after": {
        content: "\"\"",
        display: "block",
        borderLeft: "1.375px solid #363636",
        height: "100%",
        width: "0.35em",
        position: "absolute",
        bottom: "0.65em",
        left: "-0.65em"
      },

      "&:last-child:before": {
        borderLeft: "none"
      }
    },

    "& > li:last-child": {
      marginBottom: 20
    }
  },

  "& .md-headings": {
    fontSize: "inherit !important",
    listStyle: "none",
    paddingLeft: "1.25em",

    "& li": {
      fontSize: "inherit !important",
      position: "relative",

      "&:first-child": {
        marginTop: 20
      },

      "&:last-child": {
        marginBottom: "20px !important"
      },

      "&:before": {
        content: "\"\"",
        display: "block",
        borderTop: "1px solid #363636",
        borderLeft: "1px solid #363636",
        height: "100%",
        width: "0.35em",
        position: "absolute",
        bottom: "-0.65em",
        left: "-0.65em"
      },

      "&:after": {
        content: "\"\"",
        display: "block",
        borderLeft: "1px solid #363636",
        height: "100%",
        width: "0.35em",
        position: "absolute",
        bottom: "0.65em",
        left: "-0.65em"
      },

      "&:last-child:before": {
        borderLeft: "none"
      }
    }
  }
});
var tocStyleClass = tocStyle.toString();

// ----------------------------------------------------------------------------
// ----------------------------------------------------------------- TOC Parser
// ----------------------------------------------------------------------------
/** parses an array and outputs a table of contents */
var tocParser = function tocParser(postEdges, thisPath) {
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var type = arguments[3];
  var nest = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : { where: undefined, what: {} };

  var categories = _lodash2.default.uniq(_lodash2.default.map(postEdges, "node.frontmatter.category")).sort(function (a, b) {
    var A = a.toLowerCase();
    var B = b.toLowerCase();
    // sort string ascending
    if (A < B) return -1;
    if (A > B) return 1;
    // default return value (no sorting)
    return 0;
  });

  return _react2.default.createElement(
    "div",
    { className: tocStyleClass },
    _lodash2.default.map(categories, function (category, categoryIndex) {
      var categoryString = categoryIndex + 1 + ". " + _lodash2.default.split(category, ".")[1];
      return _react2.default.createElement(
        Fragment,
        null,
        _react2.default.createElement(
          "p",
          { className: "md-cat" },
          _react2.default.createElement(
            "span",
            null,
            categoryString
          )
        ),
        _react2.default.createElement(
          "ul",
          { className: "md-pages mask-p" },
          _lodash2.default.map(postEdges, function (_ref) {
            var node = _ref.node;
            return _react2.default.createElement(
              Fragment,
              null,
              node.frontmatter.category === category && _react2.default.createElement(
                "li",
                {
                  className: (_lodash2.default.startsWith(node.fields.route, "/") ? node.fields.route : "/" + node.fields.route) === thisPath && "md-page-active"
                },
                (_lodash2.default.startsWith(node.fields.route, "/") ? node.fields.route : "/" + node.fields.route) === thisPath && _react2.default.createElement(
                  "span",
                  {
                    className: "active-dot",
                    style: { marginLeft: -17.6, paddingRight: 5 }
                  },
                  "\u2022"
                ),
                _react2.default.createElement(
                  Fragment,
                  null,
                  !_lodash2.default.isUndefined(options.localLink) ? _react2.default.createElement(
                    Fragment,
                    null,
                    node.frontmatter.title === nest.where ? _react2.default.createElement(
                      Fragment,
                      null,
                      _react2.default.createElement(
                        options.localLink,
                        {
                          to: _lodash2.default.startsWith(node.fields.route, "/") ? node.fields.route : "/" + node.fields.route
                        },
                        _react2.default.createElement(
                          "span",
                          null,
                          node.frontmatter.title
                        )
                      ),
                      _react2.default.createElement(
                        "ul",
                        { className: "md-headings" },
                        _lodash2.default.map(nest.what, function (_ref2) {
                          var depth = _ref2.depth,
                              value = _ref2.value;
                          return _react2.default.createElement(
                            Fragment,
                            null,
                            depth === 1 && _react2.default.createElement(
                              "li",
                              null,
                              _react2.default.createElement(
                                "a",
                                {
                                  href: "#" + _lodash2.default.kebabCase(_lodash2.default.toLower(_lodash2.default.trim(value)))
                                },
                                _react2.default.createElement(
                                  "span",
                                  null,
                                  value
                                )
                              )
                            )
                          );
                        })
                      )
                    ) : _react2.default.createElement(
                      options.localLink,
                      {
                        to: _lodash2.default.startsWith(node.fields.route, "/") ? node.fields.route : "/" + node.fields.route
                      },
                      _react2.default.createElement(
                        "span",
                        null,
                        node.frontmatter.title
                      )
                    )
                  ) : _react2.default.createElement(
                    Fragment,
                    null,
                    node.frontmatter.title === nest.where ? _react2.default.createElement(
                      Fragment,
                      null,
                      _react2.default.createElement(
                        "a",
                        {
                          href: _lodash2.default.startsWith(node.fields.route, "/") ? node.fields.route : "/" + node.fields.route
                        },
                        _react2.default.createElement(
                          "span",
                          null,
                          node.frontmatter.title
                        )
                      ),
                      _react2.default.createElement(
                        "ul",
                        { className: "md-headings" },
                        _lodash2.default.map(nest.what, function (_ref3) {
                          var depth = _ref3.depth,
                              value = _ref3.value;
                          return _react2.default.createElement(
                            Fragment,
                            null,
                            depth === 1 && _react2.default.createElement(
                              "li",
                              null,
                              _react2.default.createElement(
                                "span",
                                null,
                                value
                              )
                            )
                          );
                        })
                      )
                    ) : _react2.default.createElement(
                      "a",
                      {
                        href: _lodash2.default.startsWith(node.fields.route, "/") ? node.fields.route : "/" + node.fields.route
                      },
                      _react2.default.createElement(
                        "span",
                        null,
                        node.frontmatter.title
                      )
                    )
                  )
                )
              )
            );
          })
        )
      );
    })
  );
};

// ----------------------------------------------------------------------------
// --------------------------------------------------------------------- Export
// ----------------------------------------------------------------------------
exports.default = tocParser;
module.exports = exports["default"];


//////////////////
// WEBPACK FOOTER
// ./~/@bodhi-project/markdown-to-react/lib/tocParser.js
// module id = 441
// module chunks = 168707334958949